import { useState, useEffect } from "react";
import { Tooltip, Typography, Button } from "@mui/material";
import { DataGrid, faIR } from "@mui/x-data-grid";
import { UseDiscountManagment } from "./UseDiscountManagment";
import { useNavigate, useLocation } from "react-router-dom";
import CustomPagination from "../../components/CustomPagination";
import ProgressCom from "../../components/ProgressCom";
import Detail from "../../main/detail/Detail";
import { toMoney } from "../../util/Utils";
import { rsGotoLast, rsProgress, rsActiveMenu } from "../../RecoilStates";
import { useRecoilState } from "recoil";
import { Link } from "react-router-dom";
import { UseOffer } from "../../ContentManagement/firstPage/HomeOffer/UseOffer";

export default function DiscountManagment() {
  const [msActiveMenu, setMsActiveMenu] = useRecoilState(rsActiveMenu);
  const { UpdateOffersDataAll, UpdateOffersAll } = UseOffer();
  const location = useLocation();
  const [progress, setProgress] = useRecoilState(rsProgress);
  const navigate = useNavigate();
  const { getDiscountList } = UseDiscountManagment();
  const [search, setSearch] = useState(
    location.state && location.state.search ? location.state.search : ""
  );
  const [pageState, setPageState] = useState({
    page: location.state && location.state.page ? location.state.page : 1,
  });
  const [discountRes, setDiscountRes] = useState();
  const [searchSubGroup, setSearchSubGroup] = useState("");
  const [filt, setFilt] = useState([]);

  useEffect(() => {
    getDiscountList(true, (discounts) => {
      setDiscountRes(discounts);
    });
  }, []);

  useEffect(() => {
    setFilt([
      {
        columnField: "discountTitle",
        operatorValue: "contains",
        value: searchSubGroup,
      },
    ]);
  }, [searchSubGroup]);

  const columns = [
    {
      field: "id",
      width: 80,
      align: "center",
      headerName: "id",
      headerAlign: "center",
    },
    {
      field: "discountTitle",
      headerName: "عنوان تخفیف",
      width: 300,
      align: "left",
      headerAlign: "center",
    },
    {
      field: "count",
      headerName: "تعداد",
      width: 130,
      align: "center",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography>
            {cellValues.row.count ? toMoney(cellValues.row.count) : 0}
          </Typography>
        );
      },
    },
    {
      field: "عملیات",
      sortable: false,
      width: 170,
      align: "center",
      headerAlign: "center",
      headerName: "عملیات",
      renderCell: (cellValues) => {
        return (
          <>
            <Tooltip title="ویرایش">
              <Button
                color="secondary"
                variant="contained"
                onClick={() => {
                  if (cellValues.row.discountName == "Direct") {
                    return navigate("/discountmanagment/directDiscount", {
                      state: {
                        page: pageState.page,
                        search: search,
                        id: cellValues.row.id,
                      },
                    });
                  }
                  if (cellValues.row.discountName == "Batch") {
                    return navigate("/discountmanagment/batchDiscount", {
                      state: {
                        page: pageState.page,
                        search: search,
                        id: cellValues.row.id,
                      },
                    });
                  }
                  if (cellValues.row.discountName == "DiscountCode") {
                    return navigate("/discountmanagment/discountCode", {
                      state: {
                        page: pageState.page,
                        search: search,
                        id: cellValues.row.id,
                      },
                    });
                  }
                }}
              >
                ویرایش
              </Button>
            </Tooltip>
            <Tooltip title="پیشنهاد">
              {cellValues.row.discountName == "Direct" ||
              cellValues.row.discountName == "Batch" ? (
                <Link
                  target="_blank"
                  to={{
                    pathname: `/discountmanagment/candidateList?discount=${cellValues.row.discountName}`,
                  }}
                >
                  <Button
                    sx={{ ml: 1 }}
                    // color="secondary"
                    variant="outlined"
                  >
                    پیشنهاد
                  </Button>
                </Link>
              ) : (
                <Button
                  sx={{ ml: 1 }}
                  // color="secondary"
                  variant="outlined"
                >
                  پیشنهاد
                </Button>
              )}
            </Tooltip>
          </>
        );
      },
    },
    {
      field: "به‌روزرسانی",
      sortable: false,
      width: 170,
      align: "left",
      headerAlign: "center",
      headerName: "به‌روزرسانی",
      renderCell: (cellValues) => {
        return (
          <>
            {(cellValues.row.discountName == "Direct" ||
              cellValues.row.discountName == "Batch") && (
              <>
                <Tooltip title="به‌روزرسانی داده">
                  <Button
                    sx={{ width: "130px" }}
                    variant="contained"
                    onClick={() => {
                      setProgress(true);
                      UpdateOffersDataAll(() => setProgress(false));
                    }}
                  >
                    به‌روزرسانی داده
                  </Button>
                </Tooltip>
                {/* <Tooltip title="به‌روزرسانی محصولات">
                  <Button
                    sx={{ width: "130px", ml: 1 }}
                    variant="contained"
                    onClick={() => {
                      setProgress(true);
                      UpdateOffersAll(() => setProgress(false));
                    }}
                  >
                    به‌روزرسانی محصولات
                  </Button>
                </Tooltip> */}
              </>
            )}
          </>
        );
      },
    },
  ];

  return (
    <Detail
      breadChilds={{
        title: "محصولات",
        childs: [{ name: msActiveMenu.pageTitle, url: "/discountmanagment" }],
      }}
    >
      {discountRes ? (
        <DataGrid
          className="ltr-grid"
          disableVirtualization
          filterModel={{
            items: filt,
          }}
          localeText={faIR.components.MuiDataGrid.defaultProps.localeText}
          columns={columns}
          rows={discountRes}
          page={pageState.page - 1}
          pageSize={20}
          Pagination
          onPageChange={(newPage) => {
            setPageState((old) => ({ ...pageState, page: newPage + 1 }));
          }}
          rowCount={discountRes && discountRes.length ? discountRes.length : 1}
          enableRangeSelection={true}
          disableColumnMenu
          hideFooterSelectedRowCount
          components={{
            Pagination: CustomPagination,
          }}
          componentsProps={{
            pagination: {
              isLtr: true,
              nofab: true,
              rowCount:
                discountRes && discountRes.length ? discountRes.length : "",
            },
          }}
          initialState={{
            sorting: {
              sortModel: [
                {
                  field: "id",
                  sort: "asc",
                },
              ],
            },
          }}
        />
      ) : (
        <ProgressCom></ProgressCom>
      )}
    </Detail>
  );
}
